import LocationModel from './Location'
import LocationRepository from './LocationRepository'
import BulkAddLocationFormModel from './BulkAddLocationForm'
import BulkAddLocationGroupAndLocationFormModel from './BulkAddLocationGroupAndLocationForm'
import getGeocoder from './getGeocoder'

// 互換性のため
export default LocationModel

export {
  LocationModel,
  LocationRepository,
  BulkAddLocationFormModel,
  BulkAddLocationGroupAndLocationFormModel,
  getGeocoder,
}
